import { useCallback } from 'react';
import './nuevoStroLight.css'
import axios from 'axios';
export default function MensajesCronologiaLight({ mensaje, user }) {
    const ocultarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(`https://back.agsseguros.online/api/ocultarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    const mostrarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(
            `https://back.agsseguros.online/api/mostrarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    const borrarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(
            `https://back.agsseguros.online/api/borrarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    return (
        <>
            {mensaje.borrar === 1 ?
                <></>
                :
                <div className={
                    mensaje.oculto === 1 ? 'mensajeCronologiaMensajeOcultarLight d-flex flex-column gap-2'
                    : (!mensaje.desc || mensaje.desc === 'null' || mensaje.desc.trim() === '') && mensaje.obs && mensaje.obs !== 'null' && mensaje.obs.trim() !== ''
                        ? 'mensajeCronologiaMensajeObsLight d-flex flex-column gap-2'
                        : 'mensajeCronologiaMensajeLight d-flex flex-column gap-2'
                }>
                    {/* Row 1: Header (Metadata, Badges & Actions) */}
                    <div className="cronologia-card-header d-flex align-items-center justify-content-between">
                        <div className="cronologia-meta-row d-flex align-items-center gap-2 flex-wrap">
                            <span className="cronologia-timestamp">{`${mensaje.fecha} | ${mensaje.hora}`}</span>
                            <span className="cronologia-meta-divider">•</span>
                            <span className="cronologia-autor"><span className="cronologia-label">Autor:</span> {mensaje.autor}</span>
                            {mensaje.motivo && (
                                <span className={
                                    mensaje.motivo === 'STRO' ? 'cronologia-badge motivoStro' :
                                    mensaje.motivo === 'AMP' ? 'cronologia-badge motivoAmp' :
                                    mensaje.motivo === 'COTI' ? 'cronologia-badge motivoCoti' :
                                    mensaje.motivo === 'CIA' ? 'cronologia-badge motivoCia' :
                                    mensaje.motivo === 'FIN' ? 'cronologia-badge motivoFin' : 'cronologia-badge'
                                }>
                                    {mensaje.motivo}
                                </span>
                            )}
                            {mensaje.jerarquia && (
                                <span className={
                                    mensaje.jerarquia === 'CRG' ? 'cronologia-badge jerarquiaCrg' :
                                    mensaje.jerarquia === 'DEN' ? 'cronologia-badge jerarquiaDen' : 'cronologia-badge'
                                }>
                                    {mensaje.jerarquia}
                                </span>
                            )}
                        </div>
                        {user === 1 || user === 53 ?
                            <div className='cronologia-acciones d-flex gap-2 align-items-center'>
                                {mensaje.oculto === 1 ?
                                    <button className="cronologia-action-btn" onClick={(e) => mostrarMensaje(e)} title="Mostrar"><i className="bi bi-eye" style={{ fontSize: '16px' }}></i></button>
                                    :
                                    <button className="cronologia-action-btn" onClick={(e) => ocultarMensaje(e)} title="Ocultar"><i className="bi bi-eye-slash" style={{ fontSize: '16px' }}></i></button>}
                                <button className="cronologia-action-btn delete-btn" onClick={(e) => borrarMensaje(e)} title="Eliminar"><i className="bi bi-trash3" style={{ fontSize: '16px' }}></i></button>
                            </div>
                            : null}
                    </div>

                    {/* Row 2: Body (Description & Observations) */}
                    <div className="cronologia-card-body d-flex flex-column">
                        {mensaje.desc && mensaje.desc !== 'null' && mensaje.desc.trim() !== '' && (
                            <div className="cronologia-desc"><span className="cronologia-label">Desc:</span> {mensaje.desc}</div>
                        )}
                        {mensaje.obs && mensaje.obs !== 'null' && mensaje.obs.trim() !== '' && (
                            <div className='cronologia-obs mt-2'>
                                <span className="cronologia-label">Obs usuario:</span> {mensaje.obs}
                            </div>
                        )}
                    </div>
                </div>}
        </>
    );
}
